module.exports = "/assets/5fd4fc412cbbf4baf477b09c219ec14b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9T.png
// module id = 1172
// module chunks = 0